import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Header } from '@3plearning/react-components';

import css from './header-with-academic-year.scss';
import { formatDate } from '../../helpers/utils';

const HeaderWithAcademicYear = (props) => {
    const { localeData, academicYear, title } = props;

    if (!localeData || !academicYear || !title) {
        return null;
    }

    const { startDate, endDate } = academicYear;
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    return (
        <div className={css.component}>
            <Header title={title} />
            <div>
                {localeData['Label - AcademicYear']}:
                <span className={css.academicYear}>
                    {' '}{formattedStartDate}{' > '}{formattedEndDate}
                </span>
            </div>
        </div>
    );
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        localeData: state.localeData,
        academicYear: state.academicYear
    };
}

HeaderWithAcademicYear.propTypes = {
    title: PropTypes.string,
    academicYear: PropTypes.object,
    localeData: PropTypes.object
};

export default connect(mapStateToProps)(HeaderWithAcademicYear);



// WEBPACK FOOTER //
// ./components/header-with-academic-year/header-with-academic-year.js